import React from 'react';
import DateFormat from 'constants/date_format';
import moment from 'moment-timezone';

const formatDate = (date, format) =>
  moment(date, DateFormat.fixed.ISO8601_LOCAL).format(format);

const placeHolderName = (
  startTime,
  endTime,
  timeZone,
  handleInitialNameChange,
  id,
) => {
  const name = `${moment(startTime, DateFormat.fixed.ISO8601_LOCAL).format(
    DateFormat.fixed.SHORT_MONTH_DAY_YEAR,
  )} at ${formatDate(startTime, DateFormat.TIME)} ${t(
    'conjunctions.to',
  )} ${formatDate(endTime, DateFormat.TIME)} ${timeZone}`;
  handleInitialNameChange(name, id);
  return name;
};

const SessionName = ({
  className,
  onChange,
  handleInitialNameChange,
  value,
  id,
  startTime,
  endTime,
  timeZone,
}) => (
  <div className={className}>
    <label className="d-b" htmlFor="sessionName" type="text" name="sessionName">
      {t('in_person_training.new_session.name')} *
    </label>
    <input
      className="NewInput NewInput--white NewInput--fw NewInput--tall fz-20"
      name="sessionName"
      aria-label="Session Name Input Field"
      aria-required="true"
      id="sessionName"
      onChange={e => onChange(e, id)}
      placeholder={t(
        'in_person_training.session.form.session_name_placeholder',
      )}
      value={
        value === 'Defaulted SessionName Holder'
          ? placeHolderName(
              startTime,
              endTime,
              timeZone,
              handleInitialNameChange,
              id,
            )
          : value
      }
      maxLength={255}
      required
    />
  </div>
);

export default SessionName;
